import { Table } from '#shared/components/UI';
import { SubAccountsListsShow } from './types';

type SubAccountsCountProps = {
  subAccount: Pick<SubAccountsListsShow, 'SubAccountsEnabled' | 'childSubAccounts'>;
  /** Opens the Sub-Accounts drawer. */
  onOpen: () => void;
};

// The Sub-Accounts column: how many direct sub-accounts the row has, under the list's status filter (ID-13661).
// "-" when the account can't have sub-accounts; a non-zero count opens the drawer.
export default function SubAccountsCount({ subAccount, onOpen }: SubAccountsCountProps) {
  if (!subAccount.SubAccountsEnabled) return '-';

  const numSubAccounts = subAccount.childSubAccounts.length;

  if (numSubAccounts === 0) return numSubAccounts;

  return <Table.LinkButton onClick={onOpen}>{numSubAccounts}</Table.LinkButton>;
}
